var React = require('react');

function Delivery (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M101.52,146.71a.534.534,0,0,0-.536.532v2.847h-1.79a.534.534,0,1,0,0,1.068h1.79v2.338h-4.2a.535.535,0,0,0,0,1.069h4.2v5.914a.534.534,0,0,0,.536.536h2.887a2.607,2.607,0,0,0,5.054,0h9.746a2.607,2.607,0,0,0,5.055,0h2.426a.534.534,0,0,0,.536-.536v-4.96a.535.535,0,0,0-.055-.232l-2.417-4.959a.534.534,0,0,0-.481-.3h-6.959v-2.783a.534.534,0,0,0-.536-.532Zm.532,1.068h14.194v12.168h-6.722a2.611,2.611,0,0,0-5.176,0h-2.295v-5.382h5.2a.535.535,0,0,0,0-1.069h-5.2v-2.338h5.2a.534.534,0,0,0,0-1.068h-5.2Zm15.261,3.316h6.624l1.9,3.891h-8.522Zm0,4.959h8.844v3.892h-1.834a2.611,2.611,0,0,0-5.176,0h-1.834Zm-10.42,2.7h.04a1.527,1.527,0,1,1-.04,0Zm14.8,0h.04a1.526,1.526,0,1,1-.04,0Z","transform":"translate(-96.248 -146.71)","fill":"#e03116"}));
}

Delivery.defaultProps = {"width":"30.978","height":"16.271","viewBox":"0 0 30.978 16.271"};

module.exports = Delivery;

Delivery.default = Delivery;
